import {  
    IonRow,
    IonGrid,
    IonCol,
    IonToggle } from '@ionic/react';

import React, { useEffect, useState, useRef } from 'react';
import { handlerOptimizeRoute, getTripFare } from "../services/handlers";

function SummaryComponent (props){
  
  
  
  const [checked, setChecked] = useState(false);
  const [priceDetails , setPriceDetails] = useState({
    "currency": "",
    "tripFare": ""
  })
  const [showLoader, setShowLoader] = useState(false)
  const myRef = useRef(1);


  // Get Trip Fare Handler
  useEffect(()=>{
    
    handleTripFare()

  },[props.deliveryAddresses.additionalStops.length])  // props.deliveryAddresses.additionalStops.length, checked

  const handleTripFare = async () => {
    if (Object.keys(props.deliveryAddresses.pickUpLocation ).length !== 0
        && Object.keys(props.deliveryAddresses.dropOffLocation ).length !== 0 && props.deliveryAddresses.calculateTripFare)
   {
      let response = await getTripFare(props.deliveryAddresses)
      setPriceDetails({...priceDetails , tripFare:response.data.price[0].detail['9'].total , currency: response.data.currency })
      props.setDeliveryAdderss(() => { return {...props.deliveryAddresses, 
      tripFare:response.data.price[0].detail['9'].total ,
      currency: response.data.currency, 
      priceId:response.data.priceID,
      duration:response.data.directions.duration ,
      distance: response.data.directions.distance,
      geometry: response.data.directions.geometry,
      calculateTripFare: false}
    })
      // setChecked(props.deliveryAddresses.routeOptimized ? props.deliveryAddresses.routeOptimized : "false")
      return
    } 
      setPriceDetails({...priceDetails , tripFare:props.deliveryAddresses.tripFare , currency: props.deliveryAddresses.currency })
    
    
    // if(props.deliveryAddresses.priceId) {
    //   setPriceDetails({...priceDetails , tripFare:props.deliveryAddresses.tripFare , currency: props.deliveryAddresses.currency })
    // }
  }

    return (
        <>
            <div className='summary'>
              <IonGrid>
                <IonRow>
                <IonCol size="7">
                  <h5>Pickup Location</h5>
                   <h4>{props.deliveryAddresses.pickUpLocation.address ? props.deliveryAddresses.pickUpLocation.address : "" }</h4>
                </IonCol>
                <IonCol size="5">
                  <h5>Total Fare</h5>
                  {
                    showLoader && <h1> Loading Price ...</h1>
                  }
                  {
                    !showLoader && <h1>{priceDetails.tripFare ? `${priceDetails.currency} ${priceDetails.tripFare}` : ""}</h1>
                  }
                   
                   <p>Inclusive of GST <br/><b>Learn more</b> about our delivery charges</p>
                </IonCol>
                </IonRow>
              </IonGrid>
              
            </div>
        </>
    )
}

export default SummaryComponent;